import React from 'react';

export const VwoContext = React.createContext({});

export const ContextVwoProvider = VwoContext.Provider;
export const ContextVwoConsumer = VwoContext.Consumer;
